export default __webpack_public_path__ + "static/events-ce402930bb62653e54cf992ae78616da.webp";